import React from 'react';
import { Box, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';

// Preview for the gateway `categories` block. Unlike `catSuggestions`, this is
// the query-results category facet list, so it stays visually plain.
const Categories = ({ maxItems = 4, hidden, ...props }) => {
  if (hidden) return null;

  // Deterministic width formula, kept independent of CatSuggestions so the
  // two previews remain visually distinct.
  const getWidth = (i) => 50 + ((i * 31) % 50);

  return (
    <Box display="flex" flexDirection="column" gap={1} {...props}>
      <Typography variant="caption" style={{ color: '#9e9e9e', fontWeight: 600, paddingLeft: 4 }}>
        <IntlMessages id="ui.searchExperienceV2.core.blocks.categories.categories" />
      </Typography>

      <Box display="flex" flexDirection="column" gap={0.25}>
        {Array.from({ length: maxItems }).map((_, i) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={`category-${i}`}
            px={1.5}
            py={0.75}
            display="flex"
            alignItems="center"
          >
            <Box width={getWidth(i)} height={8} bgcolor="#eeeeee" borderRadius={4} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Categories;
